import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import T from '../../Locale';
import { currencyFormat } from '../../../components/Tools';
import Controls from './ComponentListItemControls';
import { getType } from './ValueTypes';
class ComponentListItem extends Component {
    constructor(props) {
        super(props);
        this.state = { showAdditional: false };
        this.hasAdditionalFields = this.hasAdditionalFields.bind(this);
        this.renderAdditionalFields = this.renderAdditionalFields.bind(this);
    }
    hasAdditionalFields() {
        const { item } = this.props;
        return item.additional || item.files;
    }
    renderAdditionalFields() {
        const { item } = this.props;
        const additionalFields = [];
        // Add all additional information to the fields.
        Object.keys(item.additional).forEach((key) => {
            additionalFields.push((_jsxs("p", { children: [item.additional[key].label, _jsx("strong", { children: item.additional[key].value })] }, item.additional[key].value)));
        });
        if (item.files) {
            item.files.forEach((file) => {
                additionalFields.push((_jsxs("p", { children: [_jsx("i", { className: "fa fa-download", "aria-hidden": "true" }), _jsx("a", Object.assign({ href: `/values/${item.id}/file/${file.id}`, rel: "noopener noreferrer", target: "_blank" }, { children: file.name }))] }, file.id)));
            });
        }
        return additionalFields;
    }
    render() {
        const { item } = this.props;
        const { showAdditional } = this.state;
        const hasValue = parseInt(item.value, 10) > 0;
        const type = getType(item.type);
        return (_jsxs("div", Object.assign({ className: "callout" }, { children: [_jsxs("div", Object.assign({ className: "callout__content" }, { children: [_jsx("span", Object.assign({ className: `values__category ${type.color}-bg white-color` }, { children: type.label })), _jsxs("h5", { children: [item.name, this.hasAdditionalFields() && (_jsx("i", { onClick: () => this.setState({ showAdditional: !showAdditional }), className: "fa fa-info-circle gray-darker-color", "aria-hidden": "true" }))] }), !showAdditional && (_jsxs("div", { children: [hasValue && (_jsxs("p", { children: [T.translate('values.value'), T.translate('misc.currency'), currencyFormat(item.value), ",-"] })), !hasValue && _jsx("p", { children: T.translate('values.inputValue') }), !item.sharedWith || (_jsxs("p", { children: [_jsx("strong", { children: T.translate('values.sharedWith') }), item.sharedWith] })), !item.owner || (_jsxs("p", { children: [_jsx("strong", { children: T.translate('values.sharedBy') }), item.owner] }))] })), showAdditional && this.renderAdditionalFields()] })), _jsx(Controls, { item: item })] })));
    }
}
ComponentListItem.propTypes = { item: PropTypes.object.isRequired };
export default ComponentListItem;
